import { Route, Routes } from "react-router-dom";
import "./App.css";
import Header from "./components/header/Header";
import Footer from "./components/footer/Footer";
import Home from "./components/home/Home";
import AboutUs from "./components/aboutUs/AboutUs";
import Products from "./components/products/Products";
import Service from "./components/service/Service";
import Contact from "./components/contact/Contact";
import Colculation from "./components/colculation/Colculation";

function App() {
  return (
    <div className="App">
      <header>
        <Header />
      </header>
      <main>
        <Routes>
          <Route path={"/"} element={<Home />}></Route>
          <Route path={"/aboutUs"} element={<AboutUs />}></Route>
          <Route path={"/products"} element={<Products />}></Route>
          <Route path={"/service"} element={<Service />}></Route>
          <Route path={"/contact"} element={<Contact />}></Route>
          <Route
            path={"/product_colculation"}
            element={<Colculation />}
          ></Route>
        </Routes>
      </main>
      <footer>
        <Footer />
      </footer>
    </div>
  );
}

export default App;
